import { createSelector } from "reselect";

import { IRootReducer } from "../../Models/IRootReducer";
import { MapStyleEnum } from "../../Enums/Enums";

const getMap = (state: IRootReducer): google.maps.Map<Element> =>
    state.reportMap.googleMap;

const getMarkers = (state: IRootReducer): any[] =>
    state.reportMap.currentMarkers;

const getAnchorWindow = (state: IRootReducer): google.maps.InfoWindow =>
    state.reportMap.currentAnchorWindow;

const getMapCenter = (state: IRootReducer): google.maps.LatLng =>
    state.reportMap.mapCenter;

const getMapCenterPending = (state: IRootReducer): boolean =>
    state.reportMap.pendingMapCenterEvent;

const getMapStyles = (state: IRootReducer): React.CSSProperties =>
    state.reportMap.mapStyles;

const getMapStyleOptions = (state: IRootReducer): MapStyleEnum =>
    state.reportMap.mapStyleOptions;

const getMapZoom = (state: IRootReducer): number => state.reportMap.mapZoom;

const isMapReady = (state: IRootReducer): boolean => state.reportMap.isMapReady;

export const getMapDataSelector = createSelector(
    [
        getMap,
        getMarkers,
        getMapCenter,
        getMapStyles,
        getMapZoom,
        getAnchorWindow,
        getMapStyleOptions,
        getMapCenterPending,
        isMapReady
    ],
    (
        googleMap,
        currentMarkers,
        mapCenter,
        mapStyles,
        mapZoom,
        currentAnchorWindow,
        mapStyleOptions,
        pendingMapCenterEvent,
        isMapReady
    ) => ({
        googleMap,
        currentMarkers,
        mapCenter,
        mapStyles,
        mapZoom,
        currentAnchorWindow,
        mapStyleOptions,
        pendingMapCenterEvent,
        isMapReady
    })
);
